import { ListManipulationTrack } from './listManipulationTrack';
import { ListManipulationAction } from './listManipulationAction';

export class ListManipulation{
    track: ListManipulationTrack;
    position: number;
    action: ListManipulationAction;
}